import script from "./RenderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RenderPage.vue?vue&type=script&setup=true&lang=ts"

import "./RenderPage.vue?vue&type=style&index=0&id=06cd279a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06cd279a"]])

export default __exports__